import React, { useEffect, useState } from 'react'

export default function DigitalSweety({ svgUrl, fallbackText }) {
  const [imgError, setImgError] = useState(false)

  useEffect(() => {
    if (!svgUrl) {
      setImgError(true)
      return
    }
    const img = new window.Image()
    img.src = svgUrl
    img.onload = () => setImgError(false)
    img.onerror = () => setImgError(true)
  }, [svgUrl])

  if (imgError) {
    return <div className="digital-sweety">{fallbackText || 'Virtual Hottie'}</div>
  }

  return (
    <div
      className="digital-sweety"
      style={{
        background: `url(${svgUrl}) no-repeat 0 0`,
        minHeight: '30px',
        minWidth: '90px',
      }}
    />
  )
}